import request from '@/utils/request'
import { FetchRoleParams, CreateRoleParams, RoleParams } from '@/types/manage/roleManage'
/**
 * 租户管理后台角色列表
 */
export const fetchRoleList = (url: string, params: FetchRoleParams) => {
  return request({
    url,
    method: 'get',
    params
  })
}

/**
 * 创建租户角色权限
 */
export const createRole = (url: string, params: CreateRoleParams) => {
  return request({
    url,
    method: 'post',
    data: params
  })
}

/**
 * 租户角色分配
 */
export const assignRole = (url: string, params: any) => {
  return request({
    url,
    method: 'post',
    data: params
  })
}

/**
 * 租户角色保存
 */
export const editRole = (params: RoleParams) => {
  return request({
    url: '/blackcat/role/edit',
    method: 'post',
    data: params
  })
}

/**
 * 租户角色删除
 */
export const deleteRole = (url: string, params: RoleParams) => {
  return request({
    url: `${url}?roleId=${params.roleId}`,
    method: 'post'
  })
}

/**
 * 租户角色详情
 */
export const roleDetail = (url: string, params: RoleParams) => {
  return request({
    url,
    method: 'get',
    params
  })
}
